module.exports = __webpack_public_path__ + "media/ni_jiao_shen_me_ming_ze.d6867280.mp3";